import React, { memo } from "react";
import * as Styles from "./spacer.styles";

export const Spacer = memo(({ height, width }) => {
  return <Styles.Span $width={width} $height={height} />;
});
